import type { SVGProps } from "react";
export interface AtomIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AtomIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AtomIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.809 1.45c2.553-.853 5.232-.887 6.93.81s1.663 4.377.811 6.93c-.305.915-.73 1.857-1.26 2.809.53.952.955 1.895 1.26 2.81.852 2.553.887 5.232-.81 6.93s-4.378 1.663-6.931.811a16.7 16.7 0 0 1-2.81-1.26c-.952.53-1.895.955-2.808 1.26-2.553.852-5.233.887-6.93-.81s-1.664-4.378-.812-6.931c.305-.914.729-1.858 1.258-2.81A16.7 16.7 0 0 1 1.45 9.19c-.852-2.554-.886-5.233.812-6.93C3.958.563 6.637.597 9.19 1.449c.913.305 1.857.73 2.808 1.258a16.7 16.7 0 0 1 2.81-1.258ZM4.11 14.195q-.312.68-.528 1.326c-.767 2.3-.501 3.856.268 4.626.77.77 2.327 1.036 4.628.268q.646-.215 1.324-.529a25.7 25.7 0 0 1-3.066-2.623 26 26 0 0 1-2.626-3.068m15.776-.001a25.7 25.7 0 0 1-2.623 3.069 25.7 25.7 0 0 1-3.07 2.623q.682.313 1.328.529c2.3.768 3.856.501 4.626-.268.77-.77 1.036-2.326.268-4.626q-.216-.646-.529-1.327M12 5.329a22.8 22.8 0 0 0-3.671 2.999 22.8 22.8 0 0 0-2.999 3.67 22.8 22.8 0 0 0 2.999 3.673 22.8 22.8 0 0 0 3.67 2.997 22.8 22.8 0 0 0 3.673-2.995 22.8 22.8 0 0 0 2.997-3.674 22.8 22.8 0 0 0-2.995-3.671A22.8 22.8 0 0 0 12 5.329M8.48 3.583c-2.3-.768-3.858-.501-4.628.268-.77.77-1.035 2.327-.268 4.628q.216.646.528 1.324a25.6 25.6 0 0 1 2.626-3.066 25.7 25.7 0 0 1 3.066-2.626 13 13 0 0 0-1.324-.528m11.669.268c-.77-.769-2.326-1.035-4.626-.268q-.646.216-1.326.528c1.047.759 2.08 1.64 3.068 2.626a26 26 0 0 1 2.623 3.066q.313-.68.529-1.324c.768-2.3.502-3.858-.268-4.628"
      />
      <path
        fill={color}
        d="M12.875 12a.876.876 0 1 0-1.751.002.876.876 0 0 0 1.751-.003Zm2.25 0a3.126 3.126 0 1 1-6.25 0 3.126 3.126 0 0 1 6.25 0"
      />
    </svg>
  );
}
